import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueStripeCheckout from 'vue-stripe-checkout';

window.Vue = Vue;

Vue.config.productionTip = false

Vue.use(VueStripeCheckout, {
  publishableKey: process.env.VUE_APP_STRIPE_KEY
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
